module.exports = __webpack_public_path__ + "static/media/icn-open.925dd941.svg";